import { useState } from 'react';

const Share = () => {
    const [breakWidth] = useState(840);
    const [shareURL] = useState(encodeURIComponent(document.querySelector("[property='og:url']").content));
    const [twitterDescription] = useState(encodeURIComponent(document.querySelector("[name='twitter:description']").content))

    const getWindowDim = () => {
        let width = Math.min(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
          ),
          height = Math.min (
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.documentElement.clientHeight,
            window.innerHeight
          );
        return { width: width, height: height};
      }
      
    const fbLink = (e) => {
        e.preventDefault();
        let windowWidth = getWindowDim().width,
            left = ( windowWidth - 600) / 2,
            fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + shareURL;
        if(windowWidth > breakWidth) {
          window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
        } else {
          window.open(fbURL);
        }
      }
      // console.log(shareURL)
    const twitterLink = (e) => {
        e.preventDefault();
        let windowWidth = getWindowDim().width,
            left = (windowWidth - 600) / 2,
            twitURL = "https://twitter.com/intent/tweet?url=" + shareURL + "&text=" + twitterDescription + "&via=NZSTUFF";
        if(windowWidth > breakWidth) {
          window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
        } else {
          window.open(twitURL);
        }
      }
    return (
        <div className="stuffHeader-container__sharebar">
        {/* eslint-disable-next-line */}
        <a onClick={fbLink} className="stuffHeader-container__sharebar--FB"></a>
        {/* eslint-disable-next-line */}
        <a onClick={twitterLink} className="stuffHeader-container__sharebar--TW"></a>
      </div>
    )
}

export default Share;